/**
 * County display-name helper.
 *
 * Some datasets store bare county names ("Cook", "DuPage") while others store
 * the full name ("Cook County"). Appending " County" unconditionally produces
 * "Cook County County" for the latter, so every label that appends the suffix
 * goes through here.
 */
const COUNTY_SUFFIX = /\b(county|parish|borough)\b\.?$/i;

export function countyLabel(county: string): string {
  const trimmed = county.trim();
  return COUNTY_SUFFIX.test(trimmed) ? trimmed : `${trimmed} County`;
}
